module.exports = __webpack_public_path__ + "img/22.17126613.jpg";